import React from 'react';
import "./styles.css"

import banner600x1400 from "../../../assets/images/banner/cambioTurismo/1400X600.png"
import banner600x2500 from '../../../assets/images/banner/cambioTurismo/2500X600.png';
import banner700x400 from '../../../assets/images/banner/cambioTurismo/400X700.png';
import banner700x520 from '../../../assets/images/banner/cambioTurismo/520X700.png';
import { texts } from '../../../utils/texts';

export default function CambioTurismo() {
  // const handleRedirect = () => {
  //   window.open('https://om.ourominas.com/cartao-ourofacil-dia-das-maes', '_blank');
  // }

  const handleRedirectCompra = () => {
    window.open(`https://api.whatsapp.com/send?phone=${texts.phone}&type=phone_number&app_absent=`, '_blank')
  }

  return (
    <main className="backgroundCambioTurismo">
      <div>
        <picture>
          <source media="(max-width: 519px)" srcSet={banner700x520} />

          <source media="(min-width: 520px) and (max-width: 699px)" srcSet={banner700x520} />

          <source media="(min-width: 560px) and (max-width: 909px)" srcSet={banner700x520} />



          <source media="(min-width: 910px) and (max-width: 1400px)" srcSet={banner600x1400} />

          <source media="(min-width: 1401px)" srcSet={banner600x2500} />

          <img src={banner700x400} alt="Banner Responsivo" className="bannerImg" />
        </picture>
        <button className="compraBtnCambioTurismo" onClick={handleRedirectCompra} />
        {/* <button className="saibaMaisBtnMae" onClick={handleRedirect} /> */}
      </div>
    </main>
  );
}
